export const SEGMENT_CATEGORY_ATTRIBUTE_KEY = '_attribution' as const
